import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import keys from "../store/keys";
import { setKey } from "../store/actions";
import serviceService from "../services/service";
import moment from "moment";
import { swalError, swalSuccess, swalConfirm } from "../utils/swal";
import { useTranslation } from "react-i18next";

function ServicesManagement({ session, setKey }) {
    const { t } = useTranslation();
    const [services, setServices] = useState([]);

    useEffect(() => {
        reload();
    }, []);

    const reload = async () => {
        setKey(keys.isLoading, true);
        const result = await serviceService.getAll(session.token);
        if (result.data) {
            setServices(result.data);
        } else {
            swalError(result.error);
        }
        setKey(keys.isLoading, false);
    };

    const toggleVerify = async (id, currentStatus) => {
        await serviceService.updateStatus(session.token, id, !currentStatus);
        swalSuccess(t("status_updated_toast"));
        reload();
    };

    const handleDelete = (id) => {
        swalConfirm({
            callback: async () => {
                await serviceService.delete(session.token, id);
                swalSuccess(t("service_deleted"));
                reload();
            }
        });
    };

    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="font-weight-bold">{t("services_management")}</h2>
                <button className="btn btn-primary" onClick={reload}>{t("btn_refresh")}</button>
            </div>

            <div className="card shadow-sm border-0">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th>{t("col_provider")}</th>
                                    <th>{t("col_title")}</th>
                                    <th>{t("col_phone")}</th>
                                    <th>{t("col_status")}</th>
                                    <th>{t("col_date")}</th>
                                    <th>{t("col_actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {services.map(s => (
                                    <tr key={s._id}>
                                        <td>{s.user?.name}</td>
                                        <td>{s.title}</td>
                                        <td>{s.phone}</td>
                                        <td>
                                            {s.isVerified ?
                                                <span className="badge badge-success">{t("badge_verified")}</span> :
                                                <span className="badge badge-warning">{t("status_pending")}</span>
                                            }
                                        </td>
                                        <td>{moment(s.dateCreated).format('YYYY-MM-DD')}</td>
                                        <td>
                                            <button
                                                className={`btn btn-sm mr-2 ${s.isVerified ? 'btn-outline-warning' : 'btn-outline-success'}`}
                                                onClick={() => toggleVerify(s._id, s.isVerified)}
                                            >
                                                {s.isVerified ? t("btn_unverify") : t("btn_verify")}
                                            </button>
                                            <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(s._id)}>{t("btn_delete")}</button>
                                        </td>
                                    </tr>
                                ))}
                                {services.length === 0 && <tr><td colSpan="6" className="text-center p-4">{t("no_services")}</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => ({ session: store.session });
const mapDispatchToProps = dispatch => ({ setKey: (key, value) => dispatch(setKey(key, value)) });

export default connect(mapStateToProps, mapDispatchToProps)(ServicesManagement);
